import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bokeh-strong" data-testid="not-found-page">
      <Seo
        title="Page introuvable | Pixora"
        description="La page que vous recherchez n'existe pas ou a été déplacée."
        path="/"
        noindex
      />
      <div className="text-center max-w-md">
        <p className="text-sm uppercase tracking-[0.2em] text-[#C9A962] mb-4">Erreur 404</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-5">
          Page <span className="gradient-text">introuvable</span>
        </h1>
        <p className="text-[#B8A88A] mb-8 leading-relaxed">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <Link to="/" data-testid="back-home-btn">
          <button className="btn-primary">Retour à l'accueil</button>
        </Link>
      </div>
    </div>
  );
}
